import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { ChangeEmployerService } from '../change-employer.service';
import { Router } from '@angular/router';
import { EntityLicenseModel } from '../../../model/entityLicenseModel';
import { ChangeEmployerResponseModel } from '../../../model/changeEmployerResponseModel';
import { Subscription } from 'rxjs/Rx';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { CompleteFunctionResponseModel } from '../../../model/completeFunctionResponseModel';
import { StorageService } from '../../../shared/security/StorageService';
import { CompleteFunctionService } from '../../../shared/utils/complete-function.service';
import { CompleteFunctionRequestModel } from '../../../model/completeFunctionRequestModel';
import { MessageModel, ContentPageModel, StringWithHyperlinkParametersModel } from '../../../model/models';
import * as $ from 'jquery';
import { PaymentService } from '../../../shared/payment/payment.service';
import { WorkflowModel } from '../../../model/workflowModel';
import { SectionContentModel } from '../../../model/sectionContentModel';
import { SectionTextModel } from '../../../model/sectionTextModel';

@Component({
  selector: 'app-change-employer-receipt',
  templateUrl: './change-employer-receipt.component.html',
  styleUrls: ['./change-employer-receipt.component.css']
})
export class ChangeEmployerReceiptComponent implements OnInit, OnDestroy {


  public now: Date = new Date();
  employmentInfo: EntityLicenseModel =null;
  changeEmployerResponse: ChangeEmployerResponseModel = null;
  completeFunctionResponse: CompleteFunctionResponseModel = null;
  startFunction: StartFunctionResponseModel;
  workflow : WorkflowModel;
  agree: boolean = null;
  receiptInfo : ContentPageModel = {};

  employmentInfoSubscription: Subscription;
  employerChangeResponseSubsription: Subscription;
  employerChangeAgreementSubsription: Subscription;
  employerChangeCompleteSubscription: Subscription;
  notifyCompleteFunctionRequestModelSubscription : Subscription;

  userMessages: Array<MessageModel> = [];

  constructor(private changeEmployerService: ChangeEmployerService,
    private startFunctionService: StartFunctionService,
    private router: Router,
    private storageService: StorageService,
    private completeFunctionService : CompleteFunctionService,
    private currentPageWatcher : CurrentPageWatcherService,
    private paymentService : PaymentService) {

    this.startFunction = this.storageService.getStartFunctionData();
    // if (this.startFunction != null && this.startFunction != undefined && this.startFunction.Workflow != null) {

    //   this.startFunctionService.sendStartFunctionBrokerResp(this.startFunction);
    //   console.log("In Receipt Change Employer : " + this.startFunction.Workflow.Steps[4].StepDisplayName);
    // }
    this.employmentInfoSubscription = this.changeEmployerService.getNotifyEmploymentInformation().subscribe(data => {
      this.employmentInfo = data;
      console.log("Employment Info : " + this.employmentInfo);
    });

    this.employerChangeResponseSubsription = this.changeEmployerService.getNotifySelectedEmployer().subscribe(data => {
      this.changeEmployerResponse = data;
      console.log("Change Employer Response : " + this.changeEmployerResponse);
    });

    this.employerChangeAgreementSubsription = this.changeEmployerService.getNotifyAgreement().subscribe(data => {
      this.agree = data;
      console.log("Agree : " + this.agree);
    });

    this.employerChangeCompleteSubscription = this.completeFunctionService.getNotifyCompleteFunctionResponse().subscribe(data => {
      this.completeFunctionResponse = data;
      console.log("Complete Function Response : " + this.completeFunctionResponse);
    });
  }

  ngOnInit() {
    if(this.employmentInfo == null){
      this.employmentInfo = this.changeEmployerService.getEmploymentInfoData();
    }
    if(this.changeEmployerResponse == null){
      this.changeEmployerResponse = this.changeEmployerService.getSelectedEmployerData();

    }
    if(this.agree == null){
      this.agree = this.changeEmployerService.getAgreementData();

    }
    if(this.completeFunctionResponse != null){
      this.workflow = this.completeFunctionResponse.Workflow;
    }
    if(this.completeFunctionResponse == null &&  this.changeEmployerResponse!=null){
      this.workflow = this.changeEmployerResponse.Workflow;
    }
    if(this.completeFunctionResponse == null &&  this.changeEmployerResponse==null){
      this.workflow = this.startFunction.Workflow;
    }

    //test if payment step exist 
    if (this.completeFunctionResponse == null) {
      this.paymentService.getPaymentReceipt(this.workflow.WorkflowID).subscribe(response => {
        console.log("get receipt response : ", response);
        this.receiptInfo = response;
        //test if pay step is not yet checked
        if (this.startFunction.Workflow.Steps.filter(el => el.checked == false).length == 2) {
          //check pay step
          this.startFunctionService.getNotifyStepInProgress().emit(true);
        }
      });

    }
  }

  printPageAction() {
    window.print();
  }

  goBackHome() {
    this.router.navigate(['/home']);
  }

  printPage(){
    window.print();
  }

  
  ngOnDestroy(): void {
    this.employmentInfoSubscription.unsubscribe();
    this.employerChangeResponseSubsription.unsubscribe();
    this.employerChangeAgreementSubsription.unsubscribe();
    this.employerChangeCompleteSubscription.unsubscribe();

    this.changeEmployerService.clearAgreementData();
    this.changeEmployerService.clearEmploymentInfoData();
    this.changeEmployerService.clearSelectedEmployerData();
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
   
    if (this.completeFunctionResponse == null) {
    this.router.navigate(["/payChangeEmployer"]).then(()=>{
      this.startFunctionService.getNotifyStepInProgress().emit(false);
      this.changeEmployerService.getNotifySelectedEmployer().emit(this.changeEmployerResponse);
      this.changeEmployerService.getNotifyEmploymentInformation().emit(this.employmentInfo);
      this.changeEmployerService.getNotifyAgreement().emit(this.agree);

    })
  }
  else {
    this.router.navigate(["/reviewEmployerChange"]).then(()=>{
      this.startFunctionService.getNotifyStepInProgress().emit(false);
      this.changeEmployerService.getNotifySelectedEmployer().emit(this.changeEmployerResponse);
      this.changeEmployerService.getNotifyEmploymentInformation().emit(this.employmentInfo);
      this.changeEmployerService.getNotifyAgreement().emit(this.agree);
    
    })
  }
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/change-employer/change-employer-receipt/change-employer-receipt.component.ts